import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cp-charts',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <p>cp-charts works!</p> `,
  styles: ``,
})
export class CpChartsComponent {}
